import { render, staticRenderFns } from "./MyCollection.vue?vue&type=template&id=a203ea5e&"
import script from "./MyCollection.vue?vue&type=script&lang=js&"
export * from "./MyCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports